import { useEffect } from "react";
import "./style.css";
import { motion, useAnimation } from "framer-motion";
import Button from "components/Buttons";
import Loader from "components/Spinners/Loader";
import { scrollToPartnerRequestInfo } from "utils";

const HeroSection = ({ data, loading }) => {
  const controlsScan = useAnimation();
  const controlsFit = useAnimation();
  const controlsPerform = useAnimation();

  useEffect(() => {
    if (loading || !data?.listHeader?.[0]) {
      return;
    }
    const sequence = async () => {
      await controlsScan.start({
        opacity: 1,
        y: 0,
        transition: { duration: 2, ease: "easeOut" },
      });
      await controlsFit.start({
        opacity: 1,
        y: 0,
        transition: { duration: 1, ease: "easeOut" },
      });
      await controlsPerform.start({
        opacity: 1,
        y: 0,
        transition: { duration: 1, ease: "easeOut" },
      });
    };
    sequence();
  }, [loading, data, controlsScan, controlsFit, controlsPerform]);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-[606px] w-full bg-[#2b364b]">
        <Loader
          filledColor="#ffffff"
          className="!h-[50px] !flex !items-center !text-center !justify-center"
        />
      </div>
    );
  }

  const headerData = data?.listHeader[0];
  const isVideo = headerData?.video;

  return (
    <div className="relative flex items-center justify-center h-[606px] w-full overflow-hidden bg-[#2b364b]">
      {!isVideo && headerData?.image ? (
        <div
          aria-hidden
          className="pointer-events-none absolute inset-0 z-0 bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: `url(${headerData.image})` }}
        />
      ) : null}
      {isVideo ? (
        <video
          preload="metadata"
          autoPlay
          loop
          muted
          playsInline
          className="pointer-events-none absolute inset-0 z-0 h-full w-full object-cover"
        >
          <source src={headerData?.video} type="video/mp4" />
        </video>
      ) : null}
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 z-[1] bg-gradient-to-b from-[#0f172a]/75 via-[#1a2332]/65 to-[#2b364b]/80"
      />
      <div className="relative z-10 flex flex-col justify-center items-center px-4">
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          animate={controlsScan}
          className="uppercase font-barlowCondensed text-center text-[40px] leading-auto md:text-[96px] sm:leading-[84.7%] text-white font-bold relative"
        >
          {headerData?.title}
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={controlsFit}
          className="text-center md:text-[14px] relative z-10 text-white max-w-[350px] md:max-w-[450px] md:leading-[24px] mt-5 text-[12px] leading-auto font-montserrat"
        >
          {headerData?.description}
        </motion.p>
        {headerData?.btnLabel && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={controlsPerform}
            className="mt-6 relative z-10"
          >
            <Button
              type="button"
              className="hero-section-save-btn cursor-pointer w-[181px] h-[56px] mt-10 bg-[#2b364b] rounded-full border-none text-[#fff]"
              primary
              onClick={scrollToPartnerRequestInfo}
            >
              {headerData?.btnLabel}
            </Button>
          </motion.div>
        )}
      </div>
    </div>
  );
};

export default HeroSection;
